<template>
  <div id="app">
    <sm-header>
    </sm-header>
    <router-view />
    <sm-footer>
    </sm-footer>
  </div>
</template>

<script>
  import SmHeader from '@/components/header'
  import SmFooter from '@/components/footer'

  import { http } from './fetch/api'
  // import grayscale from './fetch/grayscale'
  export default {
    name: 'App',
    components: {
      SmHeader,
      SmFooter
    },
    created() {
      // this.$router.beforeEach((to, from, next) => {

      console.log('app')
      // this.getLoginState()
      // })
    },
    mounted() {
    },
    methods: {
      async getLoginState() {
        var data = await http.loginState()
        if (data.code == '0') {
          this.$store.state.loginState = true
        } else if (data.code == '1') {
          this.$store.state.loginState = false
        }
      }
    }
  }
</script>

<style>
  * {
    margin: 0;
    padding: 0;
  }

  body {
    filter: Gray;
  }

  img {
    filter: Gray;
  }

  input[type="radio"] {
    -webkit-appearance: none;
    /*清除复选框默认样式*/
    height: 16px;
    /*高度*/
    vertical-align: middle;
    width: 16px;
    outline: none;
    border: solid 1px #bebebe;
    border-radius: 50%;
    margin-left: 20px;
    margin-right: 5px;
  }

  input[type="radio"]:checked {
    background-image: url("./assets/radioactive.png");
    background-repeat: no-repeat;
    background-size: contain;
    border: none;

  }

  input[type="checkbox"] {
    -webkit-appearance: none;
    /*清除复选框默认样式*/
    height: 16px;
    /*高度*/
    vertical-align: middle;
    width: 21px;
    outline: none;
    background-image: url("./assets/check.png");
    background-repeat: no-repeat;
    background-size: contain;
    border: none;
  }

  input[type="checkbox"]:checked {
    background-image: url("./assets/checkactive.png");
    background-repeat: no-repeat;
    background-size: contain;
    border: none;

  }

  .el-dialog {
    background: none;
  }

  .formcenter .el-checkbox__label {
    font-size:16px;
    letter-spacing:1px;

  }

  /*#app {*/
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
  /*}*/
</style>


// WEBPACK FOOTER //
// src/App.vue